// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1zQAT","unreadBadge":"styles_unreadBadge__1qhwi","modalContent":"styles_modalContent__1mkao","modal":"styles_modal__3RYOM"};